











import { Component } from 'vue-property-decorator'
import Form from '@/components/Form/Form.vue'
import Field from '@/classes/Form/Field'
import { Actions } from '@/store/global/actions'
import FormBase from '@/classes/Form/FormBase'
import DialogBase from '@/classes/Dialog'
import { FieldTypes } from '@/components/Form/FieldTypes'
import { HttpMethod } from '@/helpers/requests'
import AdditionalDocumentModel, {
  AdditionalDocumentAttribute,
} from '@/modules/additional-documents/additional-document.model'
import UserModel from '@/modules/user/user.model'
import { Getters } from '@/store/auth/getters'
import { AxiosResponse } from 'axios'
import { OfferAttribute } from '@/modules/offer/offer.model'
import { documentsTypes } from '@/helpers/mimeTypes'

@Component({
  components: {
    Form,
  },
})
export default class Create extends DialogBase {
  user: UserModel = this.$store.getters[Getters.getUser]
  form: FormBase = new FormBase()
    .setFiles(true)
    .setEndpoint(`additional-documents/${this.meta.entry.uuid}?_method=PUT`)
    .setMethod(HttpMethod.POST)
    .setModel(AdditionalDocumentModel)
    .setEntry(this.meta.entry)
    .setFields([
      new Field().setKey(AdditionalDocumentAttribute.title).setTitle('Dokumento pavadinimas'),
      new Field()
        .setType(FieldTypes.file)
        .setKey(OfferAttribute.template)
        .setDisablePreview(true)
        .setTitle(this.meta.entry.template_document ? 'Pakeisti dokumento šabloną' : 'Pridėti dokumento šabloną')
        .setMeta({
          type: 'file',
          accept: documentsTypes.join(','),
        }),
    ])
    .setOnSuccess(this.onSuccess)

  onSuccess(data: AxiosResponse, entry: AdditionalDocumentModel): void {
    this.$store.dispatch(Actions.showSnackbar, {
      type: 'success',
      message: 'Dokumentas sėkmingai pakeistas!',
    })
    this.closeDialog()
    this.meta.onSuccess(entry)
  }

  created(): void {
    if (this.meta.entry.template_document) {
      this.form.addField(
        new Field().setType(FieldTypes.fileView).setTitle('Dokumentas').setMeta({
          document: this.meta.entry.template_document,
        }),
      )

      this.form.addField(
        new Field()
          .setType(FieldTypes.checkbox)
          .setKey(AdditionalDocumentAttribute.remove_template)
          .setTitle('Šalinti pridėtą dokumentą'),
      )
    }

    this.form.addField(
      new Field().setType(FieldTypes.checkbox).setKey(AdditionalDocumentAttribute.isActive).setTitle('Aktyvus'),
    )
  }
}
